import { renderSectionHeaderAsOfDate, renderPercentRow, renderRowGaps } from '../helpers';

export const feesModule = data => {
  let moduleString = ``;
  moduleString += renderSectionHeaderAsOfDate('Fees', `As of each fund's most recent prospectus`);
  moduleString += renderRowGaps();
  moduleString += renderPercentRow('Annual Management Fees', data.managementFee, 2);
  moduleString += renderPercentRow('Other Expenses', data.OtherFees, 2);
  moduleString += renderPercentRow('Service 12b-1', data.Service12b1Fee, 2);
  moduleString += renderPercentRow('Acquired (Underlying) Fund Fees and Expenses', data.underlyingFundsFee, 2);
  moduleString += renderRowGaps(2);
  return moduleString;
};
